export enum BancoEnum {
    BANCO_BRASIL = '001',
    CAIXA_ECONOMICA_FEDERAL = '104',
    ITAU_UNIBANCO = '341',
    SANTANDER = '033',
    NULO = '0'
}